export const ASYNC_READ = "kopaproLicense/merchant/asyncRead";
export const GET_READ_DATA = "kopaproLicense/merchant/getReadData";
export const FAKE_RANDOM_DATA = "kopaproLicense/merchant/fakeRandomData";
export const ASYNC_QUERY_LICENSES = "kopaproLicense/merchant/asyncQueryLicenses";
export const QUERY_LICENSES_SUCCESS = "kopaproLicense/merchant/queryLicensesSuccess";
export const UPDATE_MERCHANT = "kopaproLicense/merchant/updateMerchant";
export const ASYNC_SAVE_MERCHANT = "kopaproLicense/merchant/asyncSaveMerchant";
export const SAVE_MERCHANT_SUCCESS = "kopaproLicense/merchant/saveMerchantSuccess";
export const ASYNC_EDIT_MERCHANT = "kopaproLicense/merchant/asyncEditMerchant";
export const EDIT_MERCHANT_SUCCESS = "kopaproLicense/merchant/editMerchantSuccess";
export const ASYNC_READ_MERCHANT = "kopaproLicense/merchant/asyncReadMerchant";
export const READ_MERCHANT_SUCCESS = "kopaproLicense/merchant/readMerchantSuccess";
export const CLEAR_MERCHANT = "kopaproLicense/merchant/clearMerchant";

export const initialState = {   
    email: '',
    firstName: '',
    lastName: '',
    enableSecAuth: false,
    compName: '',
    addr:'',
    addr2:'',
    zipCode:0,
    city:'',
    province:'',
    country:'',
    countryCode:0,
    areaCode:0,    
    tel:0,
    compCountryCode:0,
    compAreaCode:0,
    compTel:0,
    progCode:'',
    enableSecondAuth:false,
    password:'',
    repw:'',
    irev:0,
    shoplicenses: [],
    trialCreated: false,
}

export default function reducer(state=initialState ,action){  
    switch(action.type){
        case FAKE_RANDOM_DATA:
            let randomUUID = 'xabcdsa';
            return {
                ...state,                         
                uuid:randomUUID,
                firstName: state.firstName,
                lastName: state.lastName,
                
            };
        case GET_READ_DATA:          
            return {
                ...state,
                uuid: action.payload.uuid,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName
            }
        case UPDATE_MERCHANT:{
            
            return {
                ...state,
                ...action.payload.data
            }
        }
        case READ_MERCHANT_SUCCESS:{
            return { 
                ...state,               
                ...action.payload
            }
        }
        case EDIT_MERCHANT_SUCCESS:{
            return {
                ...state,
                ...action.payload
            }
        }
        case CLEAR_MERCHANT:{
            return {
                ...initialState
            }
        }            
        default:            
        return state;
    }
}

export const asyncRead = (merchantId) => ({
    type: ASYNC_READ, uuid:merchantId
})

export const getReadData = (merchantId) => ({
    type: GET_READ_DATA, uuid:merchantId
})

export const fakeRandomData = () => ({
    type: FAKE_RANDOM_DATA
})

export const asyncQueryLicenses = (merchantId) => ({
    type: ASYNC_QUERY_LICENSES
})

export const updateMerchant = (data) => ({
    type: UPDATE_MERCHANT, payload:{
        data
    }
})

export const asyncEditMerchant = (data,callback) => ({
    type: ASYNC_EDIT_MERCHANT, payload:{
        data:data,
        callback: callback
    }
})

export const asyncSaveMerchant = (data,callback) => ({
    type: ASYNC_SAVE_MERCHANT, payload:{
        data:data,
        callback: callback
    }
})

export const readMerchant = (code,callback) => ({
    type: ASYNC_READ_MERCHANT, payload:{
        code: code,
        callback: callback
    }
})

export const readMerchantSuccess = (merchantPayload) => ({
    type: READ_MERCHANT_SUCCESS, payload:{
        ...merchantPayload
    }
})